import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComboInsightsHorizontalBorderNegative = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.49545 33.234C3.33362 32.9946 2.5 31.9717 2.5 30.7855L2.5 7C2.5 6.17157 3.17158 5.5 4 5.5L56 5.5C56.8284 5.5 57.5 6.17157 57.5 7L57.5 30.7855C57.5 31.9717 56.6664 32.9946 55.5046 33.234L30.3027 38.4271C30.103 38.4683 29.897 38.4683 29.6973 38.4271L4.49545 33.234Z" })
});
export default SvgComboInsightsHorizontalBorderNegative;
